type TBase64ToImage = {
    data: string;
};

export const Base64ToImage = ({ data }: TBase64ToImage) => (
    <img src={`${data}`} />
);
